/**
 * @generated SignedSource<<14186e5f6d28d025ea1880a33e606435>>
 * @relayHash 2aa0596b2714e4250257361e64901d01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f391d92f01f11733617a07e32ab8f160e4f623d9cc74ccf1688e0d08a5bae291

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type inProductPrefDueDateNotificationMutation$variables = {
  cloudId: string;
  isEnabled: boolean;
};
export type inProductPrefDueDateNotificationMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type inProductPrefDueDateNotificationMutation = {
  response: inProductPrefDueDateNotificationMutation$data;
  variables: inProductPrefDueDateNotificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "channel",
                "value": "IN_PRODUCT"
              },
              {
                "kind": "Variable",
                "name": "isEnabled",
                "variableName": "isEnabled"
              },
              {
                "kind": "Literal",
                "name": "type",
                "value": "DAILY_DUE_DATE_NOTIFICATION"
              }
            ],
            "kind": "ObjectValue",
            "name": "preferences.0"
          }
        ],
        "kind": "ListValue",
        "name": "preferences"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "inProductPrefDueDateNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "inProductPrefDueDateNotificationMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateGlobalPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "dailyDueDateNotification",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "JiraNotificationChannel",
                        "kind": "LinkedField",
                        "name": "inProductChannel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f391d92f01f11733617a07e32ab8f160e4f623d9cc74ccf1688e0d08a5bae291",
    "metadata": {},
    "name": "inProductPrefDueDateNotificationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f0c222582f335b65480ab3908f3f81ba";

export default node;
